import axios from 'axios';
import { useDispatch } from 'react-redux';
import { setisLogging } from '../store/authSlice';
import { useCallback, useEffect, useState } from 'react';
import {useLogs} from '../hooks';

const withGuard = (Component) => {
    
    const Wrapper = (props) =>{
        console.log('withGuard: => Starting');
        const dispatch = useDispatch();
        const [token, setToken] = useState(() => localStorage.getItem('token'));
        const[isLogin,setIsLogin] = useState(false);
        const { resultLogsPost, postDataHandler } = useLogs()
        const [isTokenExists,setIsTokenExists] = useState(true);

        useEffect(() => {
            const rawSegments = window.location.pathname.split('/').filter(Boolean);
            const tokenIndex = rawSegments.indexOf('token');
            if (tokenIndex === -1) return;

            const urlToken = rawSegments[tokenIndex + 1] || '';
            const existingToken = localStorage.getItem('token') || '';
            const shouldStoreToken = Boolean(urlToken) && urlToken !== existingToken;

            if (shouldStoreToken) {
                localStorage.setItem('token', urlToken);
                setToken(urlToken);
                setIsTokenExists(false);
            }

            const cleanedSegments = rawSegments.filter((_, index) => (
                index !== tokenIndex && index !== tokenIndex + 1
            ));
            const cleanedPath = `/${cleanedSegments.join('/')}`;
            const nextUrl = `${cleanedPath}${window.location.search || ''}${window.location.hash || ''}`;
            const currentUrl = `${window.location.pathname}${window.location.search || ''}${window.location.hash || ''}`;
            if (nextUrl !== currentUrl) {
                window.history.replaceState(null, '', nextUrl);
                window.location.replace(nextUrl);
            }
        }, []);

        const setLogsHandler = useCallback(() => {
            const _data = {
                moduleName: "SALES",
                resourceName: "SALES",
                eventName:"LOGIN",
                logContentEn: `Login user`,
                logContentAr: `تسجيل دخول`,
            }
            postDataHandler(_data);
        }, [postDataHandler]);

        const getUser = useCallback(async() =>{
            const cachedUser = JSON.parse(localStorage.getItem('user'));
            const currentToken = token || localStorage.getItem('token');
            if(cachedUser) {
                dispatch(setisLogging({user: cachedUser,isLogging: true}));
                setIsLogin(true);
            }
            if(!currentToken){
                window.location.replace(`${process.env.REACT_APP_Auth_WEB_BASE_URL}`)
                return;
            }
            try{
                const user = await axios.get(`${process.env.REACT_APP_Auth_API_BASE_URL}/users/current`,{
                    headers:{'Authorization': 'Bearer ' + currentToken}
                });
                // console.log('withGuard: => User',user);
                if(user.data){
                    localStorage.setItem('user', JSON.stringify(user.data.data.user));
                    dispatch(setisLogging({user: user.data.data.user,isLogging: true}));
                    setIsLogin(true)
                    
                }else{
                    window.location.replace(`${process.env.REACT_APP_Auth_WEB_BASE_URL}`)
                }
            }catch(error){
                console.log('withGuard: => Catch Error',error);
                window.location.replace(`${process.env.REACT_APP_Auth_WEB_BASE_URL}`)
            }
            
        }, [dispatch, token])
        
        useEffect(()=>{
            getUser();
        },[getUser]);  

        useEffect(()=>{
            if(isLogin && !isTokenExists){
                setLogsHandler();
            }
        },[isLogin, isTokenExists, setLogsHandler]); 

        useEffect(()=>{
            if(resultLogsPost && !isTokenExists){
                setIsTokenExists(true);
            }
        },[resultLogsPost, isTokenExists]);

        if(isLogin && isTokenExists){

            return <Component {...props} /> 
        }

        return null;

    }
    return Wrapper;
}

export default withGuard
